import Alpine from 'alpinejs';
import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

// import styles bundle
import 'swiper/swiper.css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

document.addEventListener('alpine:init', () => {
    Alpine.data('initHeroSliderHome', () => {
        return {
            swiper: null as Swiper | null,
            sliderPause: false,
            init() {
                const swiperParams: SwiperOptions = {
                    modules: [Navigation, Keyboard, Pagination, Autoplay, EffectFade],
                    init: false,
                    loop: true,
                    effect: "fade",
                    slidesPerView: 1,
                    autoplay: {
                        delay: 5000,
                    },
                    fadeEffect: {
                        crossFade: true,
                    },

                    pagination: {
                        clickable: true,
                        el: this.$refs.pagination,
                        type: 'bullets',    
                    },
                    navigation: {
                        prevEl: this.$refs.buttonPrev,
                        nextEl: this.$refs.buttonNext,
                    },
                };
                const swiper = new Swiper(
                    this.$refs.swiperContainer,
                    swiperParams,
                );
                this.swiper = swiper;

                this.$nextTick(() => {
                    swiper.init();
                });
            },
            pauseSlider() {
                if (this.sliderPause == false) {
                    this.sliderPause = true;
                    this.swiper?.autoplay.stop();
                } else {
                    this.sliderPause = false;
                    this.swiper?.autoplay.start();
                }
            }
        };
    });
});
